<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Access Request</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Access Request
            </div>

            <!-- breadcrumbs -->
            <!-- Role tit -->
            <div class="sub_tit">Role</div>
            <!-- //Role tit -->
            <!-- detail_Role -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>User Role <em class="txt_mandatory">*</em></th>
                        <td>
                            <select
                                class="slt_white input-58"
                                ref="userRole"
                                v-model="formData.ROLE_CD"
                            >
                                <option
                                    v-for="item in availableUserRoleList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //detail_Role -->
            <!-- Basic tit -->
            <div class="sub_tit mt40">Basic</div>
            <!-- //Basic tit -->
            <!--Basic -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Name <em class="txt_mandatory">*</em></th>
                        <td>
                            <span>
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="name"
                                    placeholder
                                    v-model="formData.NAME"
                                    v-validation
                                    maxlength="25"
                                    minlength="2"
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>English Name <em class="txt_mandatory">*</em></th>
                        <td>
                            <span>
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="ename"
                                    placeholder
                                    v-model="formData.ENAME"
                                    v-validation
                                    v-regex="'/[^a-zA-Z., ]/g'"
                                    maxlength="25"
                                    minlength="2"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <!-- if (!(roleCD == "A02" || roleCD == "A03" || roleCD == "S01" || roleCD == "S02" )) { -->
                    <tr v-if="!['', 'A02', 'A03', 'S01', 'S02'].includes(formData.ROLE_CD)" :key="formData.ROLE_CD">
                        <th>
                            ESN/IMEI Writing P/W <em class="txt_mandatory">*</em>
                            <em class="ico_info">
                                <i class="tooltip" v-html="getImeiPasswordRulesText()"></i>
                            </em>
                            <!-- <span
                                class="ico_sech_sm"
                                @click="onViewPasswordRulesClick"
                            >search아이콘</span> -->
                        </th>
                        <td>
                            <span>
                                <input
                                    type="password"
                                    class="text_input w100"
                                    ref="imei_pass"
                                    placeholder
                                    v-model="formData.IMEI_PASS"
                                    v-validation
                                    minlength="10"
                                    maxlength="20"
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>ESN/IMEI Confirm P/W <em class="txt_mandatory">*</em></th>
                        <td>
                            <span>
                                <input
                                    type="password"
                                    class="text_input w100"
                                    ref="imei_pass_conf"
                                    placeholder
                                    v-model="formData.IMEI_PASS_CONF"
                                    v-validation
                                    minlength="10"
                                    maxlength="25"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Country <em class="txt_mandatory">*</em></th>
                        <td>
                            <select
                                class="slt_white w100p"
                                ref="country"
                                v-model="formData.COUNTRY_CD"
                            >
                                <option
                                    v-for="item in availableCountryList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </td>
                        <th>E-Mail</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="email"
                                    placeholder
                                    v-model="formData.EMAIL"
                                    v-regex="'/[^0-9a-z\-_+@.#$]/gi'"
                                    v-validation
                                    readonly maxlength="100"
                                />
                            </span>
                        </td>
                    </tr>
                    <!--
                    <tr>
                        <th>Cell Phone Number <em class="txt_mandatory">*</em></th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="phone_cell_no"
                                    placeholder
                                    v-model="formData.PHONE_CELL_NO"
                                    v-regex="'/[^0-9\-+)]/gi'"
                                    maxlength="20"
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>Office Phone Number <em class="txt_mandatory">*</em></th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="phone_office_no"
                                    v-model="formData.PHONE_OFFICE_NO"
                                    v-regex="'/[^0-9\-+)]/gi'"
                                    maxlength="30"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    -->
                    <!--
                    <tr>
                        <th>Fax Number</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="fax_no"
                                    placeholder
                                    v-model="formData.FAX_NO"
                                    v-regex="'/[^0-9\-+)]/gi'"
                                    maxlength="30"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>-->
                </tbody>
            </table>
<!--            <div class="btn_wrap topLine"></div>-->
            <!-- //Basic -->
            <!-- Additional tit -->
<!--            <div class="sub_tit mt40">Additional</div>-->
            <!-- //Additional tit -->
            <!-- Additional -->
<!--            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>-->
<!--                    <tr>
                        <th>Center Name</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="cname"
                                    v-model="formData.CNAME"
                                    maxlength="25"
                                    placeholder
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>-->
<!--                    <tr>
                        <th>Center Address</th>
                        <td>
                            <ul>-->
<!--                                <li>
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w100"
                                            ref="street"
                                            v-model="formData.STREET"
                                            maxlength="50"
                                            placeholder="Street"
                                            v-clearable
                                        />
                                    </span>
                                </li>-->
<!--                                <li class="fL mt5">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w220p"
                                            ref="zipcode"
                                            placeholder="Zip Code"
                                            v-model="formData.ZIPCODE"
                                            maxlength="20"
                                            v-regex="'/[^0-9\-]/g'"
                                            v-clearable
                                        />
                                    </span>
                                </li>-->
<!--                                <li class="mt5">
                                    <span class="clearable w100-230 ml10">
                                        <input
                                            type="text"
                                            class="text_input"
                                            placeholder="City"
                                            ref="city"
                                            v-model="formData.CITY"
                                            maxlength="25"
                                            v-clearable
                                        />
                                    </span>
                                </li>-->
<!--                            </ul>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr>
                        <th>Contact Person</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="contact_user"
                                    v-model="formData.CONTACT_USER"
                                    maxlength="25"
                                    placeholder
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>-->
<!--                </tbody>
            </table>-->
            <!-- //Additional -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <div class="btn_right">
                    <a @click="onRequestButtonClick" class="btn_blue" title>Request</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue   from 'vue';
import axios from 'axios';
import { SDLUtil, DateUtil, CertUtil } from '@/utils';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import qs from 'query-string';

// used in list.map()
const arrayListToDict = item => {
    const CODE_ID = item[1].replace(/"/g, '').replace('Select', '');
    const CODE_NAME = item[0].replace(/"/g, '');

    return { CODE_ID, CODE_NAME, };
};

export default {
    name: 'hhp-cert-issue-request',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: [],
    data() {
        return {
            pageTitle: '',

            directYN: 'N',

            userData: {
                CITY: '',
                CNAME: '',
                CONTACT_USER: '',
                COUNTRY_CD: '',
                EMAIL: '',
                ENAME: '',
                FAX_NO: '',
                G_ACCOUNT_NO: '',
                G_DEL_YN: '',
                G_LOGIN_CORP: '',
                IMEI_PASS: '', // Hashed previous IMEI Pwd
                NAME: '',
                PHONE_CELL_NO: '',
                PHONE_OFFICE_NO: '',
                RHQ_INFO: '',
                ROLE_CD: '',
                STREET: '',
                ZIPCODE: '',
            },
            formData: {
                CITY: '',
                CNAME: '',
                CONTACT_USER: '',
                COUNTRY_CD: '',
                EMAIL: '',
                ENAME: '',
                FAX_NO: '',
                G_ACCOUNT_NO: '',
                G_DEL_YN: '',
                G_LOGIN_CORP: '',
                IMEI_PASS: '', // Preveious
                IMEI_PASS_CONF: '', // Preveious
                NAME: '',
                PHONE_CELL_NO: '',
                PHONE_OFFICE_NO: '',
                RHQ_INFO: '',
                ROLE_CD: '',
                STREET: '',
                ZIPCODE: '',
                // Same as userData
            },

            availableUserRoleList: [],
            availableCountryList: [],
        };
    },
    computed: {},

    created() {
        this.init();
    },
    mounted() {},

    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);

            const { reqRoleList, reqCountryList, checkYN, directYN, result } = await this.fetchInitData();

            this.setAvailableUserRoleList(reqRoleList);
            this.setAvailableCountryList(reqCountryList);

            this.checkAvailableCountryList();

            this.setCheckYN(checkYN);
            this.directYN = directYN;

            if (result.length > 0) this.setUserData(result[0]);

            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            const path = '/basis/anysvcmobile/request/RequestIssue.skp';
            return SDLUtil.getRequest(path);
            // return (
            //     axios
            //         // Loads data such as list of countries, etc...
            //         .get(`${SDLUtil.API_URL}`)
            //         .then(res => {
            //             console.log('RequestIssue', res);
            //             return res.data;
            //         })
            // );
        },
        setAvailableUserRoleList(list) {
            //setAvailableUserRoleList  if not C100  CODE_ID(S02) undisplay
        	this.availableUserRoleList = list.map(arrayListToDict);
            //console.log('ROLE_CD', this.formData.ROLE_CD);
            // this.formData.ROLE_CD = this.availableUserRoleList[0].CODE_ID;
        },
        setAvailableCountryList(list) {
            this.availableCountryList = list.map(arrayListToDict);
            //console.log('COUTNRY_CD', this.formData.COUNTRY_CD);
            this.formData.COUNTRY_CD = this.availableCountryList[0].CODE_ID;
        },

        setCheckYN(yn) {
            this.checkYN = yn;
            if (this.checkYN === 'Y') {
                SDLUtil.alert({
                    msg:
                        `You don't have an access to Mobile SVC. Please fill out the form to request an access.<br>` +
                        `(An e-mail will be sent to your inbox after the approval.)<br>` +
                        `You can check the status of the request on "Request Status" page.<br>` +
                        `[Mobile SVC Authorized Personel Only]`
                });
            }
        },

        checkAvailableCountryList() {
            const listWithoutSelect = this.availableCountryList.filter(item => item.CODE_ID !== '');
            if (listWithoutSelect.length === 0) {
                SDLUtil.alert({
                    msg:
                        'You do not have any country that you have access to.<br>' +
                        'Please contact your administrator.',
                    onOkEvt() {},
                });
            }
        },

        setUserData(data) {
            this.userData = Object.assign({}, data);
            this.formData = Object.assign({}, data);

            this.formData.IMEI_PASS = '';
            this.formData.ROLE_CD = '';
            this.formData.COUNTRY_CD = '';
        },

        onRequestButtonClick() {
            this.submitForm();
        },

        validateForm() {
            if (!this.formData.ROLE_CD) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please select a role.',
                    onOkEvt() {
                    },
                });
                return false;
            }

            if (!['', 'A02', 'A03', 'S01', 'S02'].includes(this.formData.ROLE_CD)
                && this.formData.IMEI_PASS.length === 0)
            {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'IMEI Password is required.',
                    onOkEvt() {
                        // this.$refs.imei_pass.$el.focus();
                    },
                });
                return false;
            }

            if (!this.formData.NAME || !this.formData.ENAME) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Name and English Name are required.',
                });
                return false;
            }

            if (!this.alphabetOnly(this.formData.ENAME)) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Only alphabets are allowed in English Name field.',
                });
                return false;
            }

            if (this.formData.IMEI_PASS) {
                if (this.formData.IMEI_PASS !== this.formData.IMEI_PASS_CONF) {
                    SDLUtil.alert({
                        title: 'Invalid Input',
                        msg: 'ESN/IMEI Password not matching.',
                        onOkEvt() {
                            // this.$refs.imei_pass_conf.$el.focus();
                        },
                    });
                    return false;
                }

                const validResult = CertUtil.isValidImeiPassword(
                        this.formData.IMEI_PASS,
                        JSON.parse(localStorage.getItem('loginUser')).loginId,
                        this.formData.EMAIL,
                        this.formData.ENAME,
                    );
                    console.log('validResult', validResult);

                if (typeof validResult === 'string') {
                    SDLUtil.alert({
                        title: 'Invalid ESN/IMEI Password',
                        msg: validResult,
                        onOkEvt: () => {
                        },
                    });
                    return false;
                }
            }

            if (this.formData.COUNTRY_CD === '') {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please select a country.',
                });

                return false;
            }
            /*
            if (this.formData.PHONE_CELL_NO === '') {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please enter cell phone number.',
                });

                return false;
            }

            if (this.formData.PHONE_CELL_NO) {
                const valid = this.numberAndHyphenOnly(this.formData.PHONE_CELL_NO)
                if (!valid) {
                    SDLUtil.alert({
                        title: 'Invalid Input',
                        msg: 'Only numbers and hyphens are allowed for Cell Phone No.',
                    });
                    return false;
                }
            }

            if (this.formData.PHONE_OFFICE_NO === '') {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please enter office phone number.',
                });

                return false;
            }

            if (this.formData.PHONE_OFFICE_NO) {
                const valid = this.numberAndHyphenOnly(this.formData.PHONE_OFFICE_NO)
                if (!valid) {
                    SDLUtil.alert({
                        title: 'Invalid Input',
                        msg: 'Only numbers and hyphens are allowed for Office Phone No.',
                    });
                    return false;
                }
            }

            if (this.formData.FAX_NO) {
                const valid = this.numberAndHyphenOnly(this.formData.FAX_NO)
                if (!valid) {
                    SDLUtil.alert({
                        title: 'Invalid Input',
                        msg: 'Only numbers and hyphens are allowed for Fax No.',
                    });
                    return false;
                }
            }
            */
            if (this.formData.EMAIL.length < 5) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'E-Mail address is required.',
                });
                return false;
            }

            return true;
        },

        prepFormData() {
            let formData = {
                G_ACCOUNT_NO: this.userData.G_ACCOUNT_NO,
                G_DEL_YN: this.userData.G_DEL_YN || 'Y',
                G_LOGIN_PWD: this.userData.G_LOGIN_PWD,
                G_LOGIN_CORP: this.userData.G_LOGIN_CORP,
                imei_pass: this.formData.IMEI_PASS || '',
                prev_imei_pass: this.userData.IMEI_PASS || '',
                name: this.formData.NAME,
                ename: this.formData.ENAME,
                country_cd: this.formData.COUNTRY_CD,
                phone_cell_no: this.formData.PHONE_CELL_NO,
                phone_office_no: this.formData.PHONE_OFFICE_NO,
                fax_no: this.formData.FAX_NO,
                email: this.formData.EMAIL,
                role_cd: this.formData.ROLE_CD,
                cname: this.formData.CNAME,
                street: this.formData.STREET,
                city: this.formData.CITY,
                zipcode: this.formData.ZIPCODE,
                contact_user: this.formData.CONTACT_USER,
            };

            return formData;
        },

        async submitForm() {
            if (!this.validateForm()) return;
            const formData = this.prepFormData();

            SDLUtil.showLoadingBar(true);

            const result = await this.postForm(formData);
            if (result === true) {
                SDLUtil.alert({
                    title: 'Request Submitted!',
                    msg: `Your request has been submitted.<br>You can check the status of it on 'Request Status' page.`,
                    okLabel: 'Go to Request Status',
                    onOkEvt: () => {
                        this.$router.push({ path: '/basis/anysvcmobile/request/Request' });
                    },
                });
            } else {
                if (result.error.code === 'HHP_INVALID_REQUEST')
                SDLUtil.alert({
                    title: 'Failed!',
                    msg: `Your request could not be submitted.<br>Error: ${result.error.message}`,
                    onOkEvt: () => {
                    },
                });
            }

            SDLUtil.showLoadingBar(false);
        },

        postForm(formData) {
            return axios
                .post(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestIssueProc.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    console.log('POST FORM RESULT =>> ', resp);
                    return resp.data.result;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        getImeiPasswordRulesText() {
            return CertUtil.getImeiPasswordRulesText();
            // let str = "1) The password's minimum length is 10<br>";
            // str += '2) The password must be different from the previous<br>';
            // str += '3) The password must contain the special character ! @ # $ ^ * ? _ ~<br>';
            // str += '4) No more than 3 consecutive numbers or characters<br>';
            // str += '5) The password cannot contain the user ID<br>';
            // str += '6) A repetition of 3 consecutive characters or more is not permitted<br>';
            // str += '7) The password must contain alphanumeric character';
            // SDLUtil.alert({
            //     title: 'Password Rules',
            //     msg: str,
            // });
        },

        validateImeiPassword(password, loginId = '', email = '', name = '') {
            const strNewPassword = password;
            const strUserID = loginId;
            const strEmail = email;

            // PART
            const strName = name;
            const nowDate = new Date();
            const year = String(nowDate.getYear());
            const year_prev = String(nowDate.getYear() - 1);
            const year_next = String(nowDate.getYear() + 1);

            let strEmailId = '';
            let strEmailCompany = '';

            const idx_email_id = email.indexOf('@');
            if (idx_email_id > -1) {
                strEmailId = email.substring(0, idx_email_id);
                const idx_email_company = email.indexOf('.');
                if (idx_email_company > -1) {
                    strEmailCompany = email.substring(idx_email_id + 1, idx_email_company);
                }
            }

            // FULL
            const FORBIDDEN_WORDS = [
                strUserID.toUpperCase(),
                strName.toUpperCase(),
                'SAMSUNG',
                'GSPN',
                'SERVICE',
                'SERVICIO',
                'IMEI',
                'ESN',
                'PASSWORD',
                year,
                year_prev,
                year_next,
                strEmailId.toUpperCase(),
                strEmailCompany.toUpperCase(),
                '1QAZXSW23E',
                '12QWERASDF',
                '12QWASZX3E',
                'ASDFQWER12',
                'ASDF',
                'QWER',
                'ZXCV',
            ];

            const RULES = [
                {
                    condition: password => !password,
                    msg: 'The ESN/IMEI password is required.',
                },
                {
                    condition: password => password.length < 10,
                    msg: 'The password must be 10 or more characters.',
                },
                {
                    condition: password => !password.match(/(.[a-zA-Z].[0-9])|(.[0-9].[a-zA-Z])/),
                    msg: 'The password must be alphanumeric.',
                },
                {
                    condition: password => password.match(/([&,%,>,<,',",;,},{,|])/),
                    msg: 'The password cannot contain the following special characters. e.g. & % > < \' " ; } { |',
                },
                {
                    condition: password => !password.match(/([!,@,#,$,^,*,?,_,~])/),
                    msg: 'The password must contain one of the following special characters. e.g. ! @ # $ ^ * ? _ ~',
                },
                {
                    condition: password => {
                        const passwordUpperCase = password.toUpperCase();
                        for (let i = 0; i < FORBIDDEN_WORDS.length; i++) {
                            if (!FORBIDDEN_WORDS[i]) continue;
                            if (passwordUpperCase.includes(FORBIDDEN_WORDS[i])) {
                                return `The password cannot contain a word "${FORBIDDEN_WORDS[i]}"`;
                            }
                        }
                        return false;
                    },
                    msg: '',
                },
                {
                    condition: password => {
                        let samePassword_0 = 0; //동일문자 카운트
                        let samePassword_1 = 0; //연속성(+) 카운트
                        let samePassword_2 = 0; //연속성(-) 카운트

                        let chr_pass_0, chr_pass_1, chr_pass_2, chr_pass_3;
                        const passwordLength = password.length;

                        for (let i = 0; i < passwordLength; i++) {
                            chr_pass_0 = password.charAt(i);
                            chr_pass_1 = password.charAt(i + 1);
                            chr_pass_2 = password.charAt(i + 2);
                            chr_pass_3 = password.charAt(i + 3);

                            //동일문자 카운트
                            if (chr_pass_0 == chr_pass_1 && chr_pass_0 == chr_pass_2 && chr_pass_0 == chr_pass_3) {
                                samePassword_0++;
                            }

                            //연속성(+) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == 1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == 1
                            ) {
                                samePassword_1++;
                            }

                            //연속성 역순(-) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == -1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == -1
                            ) {
                                samePassword_2++;
                            }
                        }

                        if (samePassword_0 > 0) {
                            return 'A repetition of same character 3 times or more is not permitted. (i.e. 1111, aaaa).';
                        }

                        if (samePassword_1 > 0 || samePassword_2 > 0) {
                            return 'Consecutive numbers or characters . (i.e. 123, bca).';
                        }

                        return false;
                    },
                    msg: '',
                },
            ];

            const title = 'Password Rule';
            const isValid = RULES.every(rule => {
                const isInvalid = rule.condition(strNewPassword); // isInvalid: Boolean | String
                if (isInvalid) {
                    const msg = typeof isInvalid === 'string' ? isInvalid : rule.msg;
                    SDLUtil.alert({ title, msg });
                    return false; // Stops the loop
                }
                return true;
            });

            return isValid;
        },

        numberAndHyphenOnly(value) {
            return /^(\d|-|\+|\s)+$/.test(value);
        },

        alphabetOnly(value) {
            return /^[a-zA-Z\s',]+$/.test(value);
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestCert.vue